// // src/main.js
// window.__cspNonce ||= document.querySelector('meta[name="csp-nonce"]')?.content;
// // @ts-ignore
// window.__webpack_nonce__ = window.__cspNonce;
// // @ts-ignore
// __webpack_nonce__ = window.__webpack_nonce__;

/* Stylesheets */
import './scss/vendors/bootstrap.scss'; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
import './scss/vendors/swiper.scss'; // ref: https://swiperjs.com/get-started#installation
import './scss/vendors/hamburgers.scss'; // ref: https://jonsuh.com/hamburgers/#sass
import './scss/vendors/energy-saver.scss';
import './scss/fonts.scss';
import './scss/style.scss';

/* Scripts */
import { Offcanvas, Modal, Accordion, Collapse } from 'bootstrap'; // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.
import { formatGeneral, formatDate } from 'cleave-zen';
import Swiper from 'swiper'; // ref: https://swiperjs.com/get-started#install-from-npm
import { Navigation, Pagination, A11y, Autoplay, Mousewheel } from 'swiper/modules';

// import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { faFacebookF, faInstagram, faXTwitter, faYoutube, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
// import { faUser, faChevronRight, faChevronLeft, faStar } from '@fortawesome/pro-regular-svg-icons';
// import {faCheck} from '@fortawesome/pro-solid-svg-icons';
// library.add(faCheck, faStar); 
// dom.i2svg(); // Converts <i> tags to SVGs
 
import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { faFreeB } from '@fortawesome/free-brands-svg-icons';
// import { faFreeS } from '@fortawesome/free-solid-svg-icons';
// import { faFreeR } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
// import { faProL } from '@fortawesome/pro-light-svg-icons';
// import { faProT } from '@fortawesome/pro-thin-svg-icons';
// import { faProD } from '@fortawesome/pro-duotone-svg-icons';
// import { faDuotoneR } from '@fortawesome/duotone-regular-svg-icons';
// import { faDuotoneL } from '@fortawesome/duotone-light-svg-icons';
// import { faDuotoneT } from '@fortawesome/duotone-thin-svg-icons';
import { faStar } from '@fortawesome/sharp-solid-svg-icons';
// import { faSharpR } from '@fortawesome/sharp-regular-svg-icons';
// import { faSharpL } from '@fortawesome/sharp-light-svg-icons';
// import { faSharpT } from '@fortawesome/sharp-thin-svg-icons';
// import { faSharpD } from '@fortawesome/sharp-duotone-solid-svg-icons';
// import { faSharpDR } from '@fortawesome/sharp-duotone-regular-svg-icons';
// import { faSharpDL } from '@fortawesome/sharp-duotone-light-svg-icons';
// import { faSharpDT } from '@fortawesome/sharp-duotone-thin-svg-icons';
// import { faFree } from '@fortawesome/fontawesome-free';
// import { faPro } from '@fortawesome/fontawesome-pro';
library.add(faCheck, faStar, faCircle);
// library.add(faDuotoneR, faDuotoneL, faDuotoneT);
// library.add(faSharpS, faSharpR, faSharpL, faSharpT, faSharpD, faSharpDR, faSharpDL, faSharpDT);
// library.add(faFree, faPro);
dom.i2svg();


import EnergySaver from './js/vendors/energy-saver';
const energyS = new EnergySaver();
let key = "";

/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

/* Variables and functions */
const offcanvasNav = document.getElementById('offcanvasNav');
const isDebug = process.env.NODE_ENV !== 'production';
let windowWidth = 0;
const initWebpackVersion = () => {
    isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

// Scroll to section
const scrollToSection = (id) => {
    let anchor = document.querySelector(`[data-anchor="${id}" ]`);
    let anchorPositionY = anchor.getBoundingClientRect().top;
    if (document.querySelector('header')) {
        let headerHeight = document.querySelector('header').offsetHeight;
        window.scrollBy(0, anchorPositionY-headerHeight);
    } else {
        window.scrollBy(0, anchorPositionY);
    }

    if (offcanvasNav.classList.contains('show')) {
        let offcanvasInstance = Offcanvas.getInstance(offcanvasNav);
        offcanvasInstance.hide();
    }
    if (window.history.pushState) {
        window.history.pushState(null, null, window.location.pathname + window.location.search);
    } else {
        window.location.hash = '';
    }
}

// Cleave
const initCleave = () => {

    const Input_Data = document.getElementById('Input_Data');
    Input_Data?.addEventListener('input', (e) => {
        Input_Data.value = formatDate(e.target.value, {
            delimiter: '/',
            datePattern: ['d', 'm', 'Y'],
        });
    });

}

// Check page scroll

let scrollTop;

document.addEventListener("scroll", (event) => {
    scrollTop = (window.scrollY !== undefined) ? window.scrollY : (document.documentElement || document.body.parentNode || document.body).scrollTop; 
    if (document.querySelector('header')) {
        // isDebug && console.log('Header found on this page');
        if (scrollTop > 0) {
            document.getElementsByClassName('header')[0].classList.add('is-scrolled');
        } else {
            document.getElementsByClassName('header')[0].classList.remove('is-scrolled');
        }
    } else {
        // isDebug && console.log('No header on this page');
        return;
    }
});

// Menu
const initMenu = () => {
    let hash = window.location.hash;
    if (hash) {
        scrollToSection(hash.substring(1));
    }
    window.addEventListener('hashchange', () => {
        hash = window.location.hash;
        scrollToSection(hash.substring(1));
    });

    offcanvasNav.addEventListener('show.bs.offcanvas', event => {
        setTimeout(() => {
            document.querySelector('.main-container').classList.add('menu-is-active');
        }, 200);
    });
    offcanvasNav.addEventListener('hide.bs.offcanvas', event => {
        setTimeout(() => {
            document.querySelector('.main-container').classList.remove('menu-is-active');
        }, 150);
    });
    window.onscroll = () => {
        if (document.querySelector('header')) {
            // isDebug && console.log('Header found on this page');
            if(scrollTop > 0) {
                document.querySelector('.header').classList.add('is-scrolled');
            } else {
                document.querySelector('.header').classList.remove('is-scrolled');
            }
        } else {
            // isDebug && console.log('No header on this page');
            return;
        }
    };
}

// initPwdVisibility
const initPwdVisibility = () => {
    let btnPwdVisible = document.querySelectorAll('.btn-show-hide-pwd');
    let textShowPwd = "Clicca qui per mostrare la password";
    let textHidePwd = "Clicca qui per nascondere la password";
    btnPwdVisible.forEach(btn => {
        btn.addEventListener('click', function () {
            let thisInput = btn.parentElement.parentElement.querySelector('input');
            let thisType = thisInput.getAttribute('type');            
            thisInput.setAttribute('type', thisType === 'password' ? 'text' : 'password');
            this.setAttribute('aria-label', thisType === 'password' ? textHidePwd : textShowPwd);
            if (thisType === 'password') {
                this.querySelector('svg.icon-on').classList.add('d-none');
                this.querySelector('svg.icon-off').classList.remove('d-none');
            } else {
                this.querySelector('svg.icon-on').classList.remove('d-none');
                this.querySelector('svg.icon-off').classList.add('d-none');
            }
        });   
    });    
}

const initFormValidation = () => {
    const forms = document.querySelectorAll('.needs-validation');
    if (forms) {
        Array.from(forms).forEach(form => {

            let allInputs = form.querySelectorAll('input, select, textarea');
            allInputs.forEach(function (el) {

                // Listener generico sui cambi
                el.addEventListener('change', function () {

                    // --- VALIDAZIONE CUSTOM PER Input_Prodotti SU CHANGE ---
                    if (el.id === 'Input_Prodotti') {
                        const invalidProdotti = form.querySelector('#InvalidProdotti');
                        const value = el.value;

                        const noProductsSelected = !value || value === '[]';

                        if (noProductsSelected) {
                            isDebug && console.log('Nessun prodotto selezionato');
                            el.setCustomValidity('Aggiungere almeno un prodotto');
                            if (invalidProdotti) {
                                invalidProdotti.textContent = 'Aggiungere almeno un prodotto';
                            }
                        } else {
                            isDebug && console.log('Prodotto selezionato');
                            el.setCustomValidity('');
                            if (invalidProdotti) {
                                invalidProdotti.textContent = '';
                            }
                        }
                    }
                    // --- FINE VALIDAZIONE CUSTOM ---

                    if (el.checkValidity()) {
                        el.removeAttribute('aria-invalid');
                    } else {
                        el.setAttribute('aria-invalid', 'true');
                    }
                });
            });

            form.addEventListener('submit', e => {

                // --- VALIDAZIONE CUSTOM PER Input_Prodotti SU SUBMIT ---
                const inputProdotti = form.querySelector('#Input_Prodotti');
                const invalidProdotti = form.querySelector('#InvalidProdotti');

                if (inputProdotti) {
                    const value = inputProdotti.value;
                    const noProductsSelected = !value || value === '[]';

                    if (noProductsSelected) {
                        inputProdotti.setCustomValidity('Seleziona almeno un prodotto');
                        document.getElementById('categoriaSelect').setAttribute('required', 'true');
                        document.getElementById('categoriaSelect').setAttribute('aria-required', 'true');
                        document.getElementById('prodottoSelect').setAttribute('required', 'true');
                        document.getElementById('prodottoSelect').setAttribute('aria-required', 'true');
                        document.getElementById('qtySelect').setAttribute('required', 'true');
                        document.getElementById('qtySelect').setAttribute('aria-required', 'true');
                        if (invalidProdotti) {
                            invalidProdotti.textContent = 'Seleziona almeno un prodotto';
                        }
                    } else {
                        inputProdotti.setCustomValidity('');
                        document.getElementById('categoriaSelect').removeAttribute('required');
                        document.getElementById('categoriaSelect').removeAttribute('aria-required');
                        document.getElementById('prodottoSelect').removeAttribute('required');
                        document.getElementById('prodottoSelect').removeAttribute('aria-required');
                        document.getElementById('qtySelect').removeAttribute('required');
                        document.getElementById('qtySelect').removeAttribute('aria-required');
                        if (invalidProdotti) {
                            invalidProdotti.textContent = '';
                        }
                    }
                }
                // --- FINE VALIDAZIONE CUSTOM ---

                form.classList.add('was-validated');

                let validFields = form.querySelectorAll('*:valid');
                let invalidFields = form.querySelectorAll('*:invalid');
                validFields.forEach(function (validField) {
                    validField.removeAttribute('aria-invalid');
                });
                invalidFields.forEach(function (invalidField) {
                    invalidField.setAttribute('aria-invalid', 'true');
                });

                if (!form.checkValidity()) {
                    e.preventDefault()
                    e.stopPropagation()
                    invalidFields[0].focus();
                    invalidFields[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                    document.querySelectorAll('.btn-show-hide-pwd').forEach(btn => {
                        const input = btn.closest('form')?.querySelector('input.password');
                        if (input) {
                            btn.style.setProperty('max-height', input.scrollHeight + 2 + 'px');
                        }
                    });
                } else {
                    e.submitter.classList.add('d-none');
                    // Find the next element with btn-loading class after e.submitter
                    let nextBtnLoading = e.submitter.nextElementSibling;
                    while (nextBtnLoading && !nextBtnLoading.classList.contains('btn-loading')) {
                        nextBtnLoading = nextBtnLoading.nextElementSibling;
                    }
                    nextBtnLoading.classList.remove('d-none');
                    document.querySelector('.loader-layer').classList.remove('d-none');
                }
            }, false);
        });
    }
}

const fixMainHeight = () => {
    // isDebug && console.log('Fixing main height...');
    
    const doc = document.documentElement;
    const currentWindowWidth = window.innerWidth;

    if (currentWindowWidth !== windowWidth) {
        windowWidth = currentWindowWidth;

        const headerHeight = document.querySelector(".header")?.clientHeight || 0;
        const footerHeight = document.querySelector(".footer")?.clientHeight || 0;
        const mainStyle = getComputedStyle(document.querySelector("main")) || {};
        const mainMarginTop = parseInt(mainStyle?.marginTop, 10) || 0;
        const mainMarginBottom = parseInt(mainStyle?.marginBottom, 10) || 0;

        const mainHeight =
            window?.innerHeight -
            headerHeight -
            footerHeight -
            mainMarginTop -
            mainMarginBottom;

            // isDebug && console.log("mainHeight:", mainHeight);
        if (mainHeight > 0) {
            doc.style.setProperty("--fix-main-height", `${mainHeight}px`);
        }
    }
};

const send = async () => {
    showLoading();

    const voto = document.querySelector('input[name="voto"]:checked').value;
    isDebug && console.log(voto);

    if (voto == null) return;
    if (azione == null) return;
    
    await sendEvaluation(azione, voto);
}

const sendEvaluation = (azione, voto) => {
    const data = {
        idAzione: azione,
        voto: voto
    };
    isDebug && console.log(data);
    const jsonData = JSON.stringify(data);

    const token = document.querySelector('input[name="__RequestVerificationToken"]').value;
    isDebug && console.log(token);

    fetch('/Storico?handler=Valuta', {
        method: 'POST',
        body: jsonData,
        headers: {
            'Content-Type': 'application/json',
            'RequestVerificationToken': token
        }
    })
    .then(r => r.json())
    .then(data => { 
        isDebug && console.log(data);
        if (data.success) 
        {
            pageReload = true;
            if (voto == "1" || voto == "2" )
            {
                // Mostro il messaggio per la valutazione bassa
                document.getElementById("step2").classList.add("d-none");
                document.getElementById("step3").classList.remove("d-none");
                return;
            }
            else 
            {
                // Voto superiore a 2: chiudo la modale
                valutationModal.hide();
                return;
            }
        }
        else 
        {
            // Chiamata senza successo: chiudo la modale
            valutationModal.hide();
            return;
        }
    })
    .catch(err => console.error("Errore:", err))
    .finally(fin => hideLoading());
}

const hideLoading = () => {
    // isDebug && console.log('hide loading');
    document.querySelector('.loader-layer').classList.add('d-none');
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
    
    if (document.querySelector('.loader-layer')) {
        document.querySelectorAll('.hide-on-loading').forEach(el => {
            el.classList.remove('d-none');
        });
        document.querySelectorAll('.show-on-loading').forEach(el => {
            el.classList.add('d-none');
        });
    }
}

const showLoading = () => {
    // isDebug && console.log('show loading');
    document.querySelector('.loader-layer').classList.remove('d-none');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    if (document.querySelector('.loader-layer')) {
        document.querySelectorAll('.hide-on-loading').forEach(el => {
            el.classList.add('d-none');
        });
        document.querySelectorAll('.show-on-loading').forEach(el => {
            el.classList.remove('d-none');
        });
    }
}

/**/

(function () {
    var BANNER_KEY = 'cookieBannerAcknowledgedAt';
    var ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000; // circa un mese

    function shouldShowBanner() {
      var stored = localStorage.getItem(BANNER_KEY);
      if (!stored) {
        // mai visto prima
        return true;
      }

      var savedTime = parseInt(stored, 10);
      if (isNaN(savedTime)) {
        // valore strano, per sicurezza lo consideriamo come se non fosse mai visto
        return true;
      }

      var now = Date.now();
      return (now - savedTime) > ONE_MONTH_MS; // se è passato più di un mese, lo rimostro
    }

    function showBanner() {
      var banner = document.getElementById('cookie-banner');
      if (banner) {
        banner.style.display = 'block';
      }
    }

    function hideBanner() {
      var banner = document.getElementById('cookie-banner');
      if (banner) {
        banner.style.display = 'none';
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      // Mostra il banner solo se necessario
      if (shouldShowBanner()) {
        showBanner();
      }

      // Gestione click sul pulsante
      var btn = document.getElementById('cookie-banner-button');
      if (btn) {
        btn.addEventListener('click', function () {
          // Salviamo il timestamp corrente
          localStorage.setItem(BANNER_KEY, Date.now().toString());
          hideBanner();
        });
      }
    });
  })();

/************/

/* Ready callback function */
ready(() => {
    initWebpackVersion();
    initCleave();
    initMenu();
    initFormValidation();
    initPwdVisibility();
    fixMainHeight();
    
    isDebug && console.log('Document ready!');
    window.addEventListener('resize', fixMainHeight);
    window.addEventListener('scroll', fixMainHeight);

});

window.scrollToSection = scrollToSection;
window.send = send;
window.showLoading = showLoading;
window.hideLoading = hideLoading;
window.initFormValidation = initFormValidation;